'use client'

import { fetchSuccess } from '@/shared/store/slice/cartSlice'
import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { redirect, useSearchParams } from 'next/navigation'
import { getOrderidFromSession } from '@/shared/store/slice/cartSlice'

export const OrderSuccessPage = () => {
    const dispatch = useDispatch()
    const search = useSearchParams()
    const navigate = (path) => redirect(path)
    const queryParams = new URLSearchParams(search)

    const { orderId, paymentMethodValue } = useSelector(
        (state) => state.cartActions
    )

    const transactionId = queryParams.get('transaction_id')

    useEffect(() => {
        if (transactionId && !orderId) {
            dispatch(getOrderidFromSession())
        }
    }, [])

    useEffect(() => {
        if (!(orderId || transactionId)) {
            navigate('/')
        }
    }, [])

    // useEffect(() => {
    //     console.log(orderId, transactionId)
    // }, [orderId, transactionId])

    if (paymentMethodValue === 'modulbank' && !transactionId) {
        return <div>Проблемы с оплатой</div>
    }

    const { userAuth, userInfo } = useGetIsAuthUser()

    useEffect(() => {
        if (!orderId) return
        dispatch(
            fetchSuccess({
                is_user_auth: userAuth,
                user_id: userAuth && userInfo.id ? userInfo.id : 0,
                transaction_id: transactionId,
            })
        )
    }, [orderId])

    return (
        <div>
            <p>Ваш заказ № <strong style={{ fontSize: '20px' }}>{orderId}</strong> принят!</p>
            {orderId && transactionId && <p>Заказ оплачен.</p>}
            <p>Заказ передаётся на сборку.</p>
            <p>
                Если у вас возникли вопросы, пожалуйста, свяжитесь с нами любым
                удобным для Вас способом.
            </p>
            <p>Мы работаем с понедельника по пятницу с 10 до 18 часов.</p>
            <p>Благодарим Вас за выбор Академия клаб и обращение на наш сайт!</p>

            <Button onClick={() => navigate('/')}>Продолжить</Button>
        </div>
    )
}
